import { render, staticRenderFns } from "./PointCreditTechcoinComplete.vue?vue&type=template&id=e5ebac06"
import script from "./PointCreditTechcoinComplete.vue?vue&type=script&lang=js"
export * from "./PointCreditTechcoinComplete.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports